import './i18n';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { UploadPage } from './components/UploadPage';
import { RmetPage } from './components/RmetPage';
import reportWebVitals from './reportWebVitals';

// Public, unauthenticated pages are forked here so they never mount App's
// Cognito bootstrap. Anything else falls through to the authenticated app.
const uploadMatch = window.location.pathname.match(/^\/upload\/([^/]+)/);
const rmetMatch = window.location.pathname.match(/^\/rmet\/([^/]+)/);

const publicPage = rmetMatch ? (
  <RmetPage sessionToken={rmetMatch[1]} />
) : uploadMatch ? (
  <UploadPage sessionToken={uploadMatch[1]} />
) : null;

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<React.StrictMode>{publicPage ?? <App />}</React.StrictMode>);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
